module.exports = __webpack_public_path__ + "static/img/Home03@2x.d0a4d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home03@2x.png
// module id = LOLE
// module chunks = 1